export const MAP_RAILWAY_SOURCE = 'railway-source';
export const MAP_RAILWAY_LAYER = 'railway-layer';
export const MAP_TRACK_SWITCH_SOURCE = 'track-switch-source';
export const MAP_TRACK_SWITCH_LAYER = 'track-switch-layer';
export const SCHEDULED_STOP_POINT_SOURCE_PREFIX = 'scheduled_stop_point_source';
export const SCHEDULED_STOP_POINT_LAYER_PREFIX = 'scheduled_stop_point_layer';
